import { getQaSelector } from '../../../../utils/common'
import { Skeleton } from '../../../Skeleton'

import {
  GRETA_AI_CHAT_PROJECTS_PAGE_SKELETON_COUNT,
  QA_NAME_GRETA_AI_CHAT_PROJECTS_PAGE_SKELETON,
} from './GretaAIChatProjectsPageSkeleton.constants'

import * as styles from './GretaAIChatProjectsPageSkeleton.module.css'

function GretaAIChatProjectsPageSkeleton() {
  return (
    <div
      {...getQaSelector({
        value: QA_NAME_GRETA_AI_CHAT_PROJECTS_PAGE_SKELETON,
      })}
      aria-hidden
      className={styles.grid}
    >
      {Array.from({ length: GRETA_AI_CHAT_PROJECTS_PAGE_SKELETON_COUNT }).map(
        (_, index) => (
          <div className={styles.card} key={index}>
            <Skeleton className={styles.title} />
            <Skeleton className={styles.scope} />
            <Skeleton className={styles.meta} />
          </div>
        )
      )}
    </div>
  )
}

export default GretaAIChatProjectsPageSkeleton
